module.exports = __webpack_public_path__ + "img/yurt-img-2.ab8729a9.jpg";